import { Menu, MenuButton, MenuList, Flex } from '@chakra-ui/react';
import React from 'react';

import {
  FundingRequestEntitiesFragmentGQLType,
  ShareFundingComponentFragmentGQLType,
  ResolvedLoanFragmentGQLType,
} from '../../../../../../types/dashboard-core-gqlTypes.generated.d';
import {
  MarkLenderShareComponentFundedButton,
  MarkLenderShareComponentFundedMenuItem,
} from './MarkFundedActions';
import { UndoLenderShareComponentFundedMenuItem } from './UndoMarkFunded';
import { Icon } from '~/packages/common-frontend/components/icons';
import { Typography } from '~/packages/common-frontend/components/Typography';

interface MarkFundedWrapperProps {
  loan: ResolvedLoanFragmentGQLType;
  fundingRequest: FundingRequestEntitiesFragmentGQLType;
  fundingComponent: ShareFundingComponentFragmentGQLType;
}
export const MarkFundedButtonWrapper = ({
  loan,
  fundingRequest,
  fundingComponent,
}: MarkFundedWrapperProps) => {
  const isAdminAgent =
    loan.parties.adminAgentOrganization?.id ===
    fundingComponent.lenderOrganizationId;

  // Can only mark as funded if loan is in "initiated" or "funded" or "overdue" state.
  // For "initiated" (per product), the admin agent may collect money from
  // their participants prior to borrower actually receiving the ACH transfer
  if (
    loan.calculatedLoanStatus !== 'initiated' &&
    loan.calculatedLoanStatus !== 'funded' &&
    loan.calculatedLoanStatus !== 'overdue'
  ) {
    return <Typography>--</Typography>;
  }

  // *** Funding Component Not Marked Yet ***
  if (!fundingComponent.fundTransferDate) {
    return (
      <MarkLenderShareComponentFundedButton
        fundingRequest={fundingRequest}
        fundingComponent={fundingComponent}
        resolvedLoan={loan}
      />
    );
  }

  // *** Funding Component Already Marked ***
  if (isAdminAgent) {
    return (
      <Typography
        fontWeight="semibold"
        colorScheme="v2-aurora"
        TextProps={{ textAlign: 'left' }}
      >
        Funded
      </Typography>
    );
  }

  return (
    <Menu>
      <MenuButton fontSize="14px" fontWeight="500" w="full">
        <Flex alignItems="center">
          <Typography
            fontWeight="semibold"
            colorScheme="v2-aurora"
            TextProps={{ textAlign: 'left', mr: '2' }}
          >
            Funded
          </Typography>
          <Icon icon="chevron-down" />
        </Flex>
      </MenuButton>
      <MenuList>
        <MarkLenderShareComponentFundedMenuItem
          fundingRequest={fundingRequest}
          fundingComponent={fundingComponent}
          resolvedLoan={loan}
        />
        <UndoLenderShareComponentFundedMenuItem
          fundingComponent={fundingComponent}
          resolvedLoan={loan}
        />
      </MenuList>
    </Menu>
  );
};
